// extracted by mini-css-extract-plugin
export default {"category_parent_name":"styles_category_parent_name__2B04k"};